<template>
<div class="vx-col md:w-full w-full mb-base">

    <vs-popup :title="titulo" :active.sync="modalMenu">
        <div class="vx-row mt-4">
            <div class="vx-col  w-full" align="left">
                <div style="font-size: 12px; ">Grupo/perfil: </div>
                <v-select class="mb-4 w-full" v-model="grupoSelect" :options="grupos" label="nombre" :reduce="grupos => grupos" placeholder="Seleccione..." />
            </div>
            <div class="vx-col  w-full" align="left">
                <div style="font-size: 12px; ">Nombre: </div>
                <!-- <vs-input type="text" class="inputx w-full mb-4" v-model="menu.idmenu" maxlength="100"  /> -->
                <vs-input type="text" class="inputx w-full mb-4" v-model="menu.name" maxlength="100" placeholder="Nombre del menú" />
            </div>
            <div class="vx-col  w-full" align="left">
                <div style="font-size: 12px; ">Url: </div>
                <vs-input type="text" class="inputx w-full mb-4" v-model="menu.url" maxlength="100" placeholder="Ruta del menú" />
            </div>
            <div class="vx-col  w-1/2" align="left">
                <div style="font-size: 12px; ">Icono: </div>
                <vs-input type="text" class="inputx w-full mb-4" v-model="menu.icon" maxlength="100" placeholder="ActivityIcon" />
            </div>
            <div class="vx-col  w-1/2" align="left">
                <div style="font-size: 12px; ">Orden: </div>
                <vs-input type="numer" class="inputx w-full mb-4" v-model="menu.orden" />
            </div>

            <div class="vx-col w-full mt-4">
                <vs-button icon-pack="feather" icon="icon-plus" class="mr-2" :color="color_boton" @click="agregar_editar()">{{txt_boton}}</vs-button>
            </div>
        </div>
    </vs-popup>

    <div>
        <vs-table max-items="20" search pagination :data="listaMenu" style="margin-top:-20px">
            <template slot="header">
                <div class="vx-row">
                    <div class="vx-col w-full mt-4">
                        <vs-button icon-pack="feather" icon="icon-plus" class="mr-2" color="primary" @click="agregarModal()">Agregar menú</vs-button>
                    </div>
                    <div class="vx-col w-full">
                        <br>
                        <vs-radio class="mt-4 mb-3 m-2" color="success" v-model="opciones" @change="perfiles" vs-value="0">Todos</vs-radio>
                        <vs-radio class="mt-4 mb-3 m-2" color="success" v-model="opciones" @change="perfiles" vs-value="admin">Administrador</vs-radio>
                        <vs-radio class="mt-4 mb-3 m-2" color="success" v-model="opciones" @change="perfiles" vs-value="docente">Docentes</vs-radio>
                        <vs-radio class="mt-4 mb-3 m-2" color="success" v-model="opciones" @change="perfiles" vs-value="estudiante">Estudiantes</vs-radio>
                        <vs-radio class="mt-4 mb-3 m-2" color="success" v-model="opciones" @change="perfiles" vs-value="vendedores">Vendedores</vs-radio>
                    </div>
                    <div class="vx-col w-full">
                        <br>
                        Cantidad: {{listaMenu.length}}
                    </div>
                </div>
            </template>
            <template slot="thead">
                <vs-th sort-key="nombre">Nombre</vs-th>
                <vs-th sort-key="url">Url</vs-th>
                <vs-th sort-key="icon">Icono</vs-th>
                <vs-th sort-key="orden">orden</vs-th>
                <vs-th sort-key="grupo">Grupo</vs-th>
                <vs-th>Acciones</vs-th>
            </template>
            <template slot-scope="{data}">
                <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                    <vs-td>
                        {{data[indextr].name}}
                    </vs-td>
                    <vs-td>
                        {{data[indextr].url}}
                    </vs-td>
                    <vs-td>
                        {{data[indextr].icon}}
                    </vs-td>
                    <vs-td>
                        {{data[indextr].orden}}
                    </vs-td>
                    <vs-td>
                        {{data[indextr].grupo}}
                    </vs-td>
                    <vs-td>
                        <vx-tooltip style="display: inline-block;" text="editar" position="top" color="dark">
                            <vs-button type="border" size="small" icon-pack="feather" icon="icon-edit" class="mr-2" color="dark" @click="editarModal(tr)"></vs-button>
                        </vx-tooltip>
                        <vx-tooltip style="display: inline-block;" text="eliminar" position="top" color="danger">
                            <vs-button type="border" size="small" icon-pack="feather" icon="icon-trash" class="mr-2" color="danger" @click="confirmaEliminar(tr)"></vs-button>
                        </vx-tooltip>
                    </vs-td>
                </vs-tr>
            </template>
        </vs-table>
    </div>
</div>
</template>

<script>
import vSelect from 'vue-select'
export default {
    components: {
        'v-select': vSelect,
    },
    data() {
        return {
            listaMenu: '',
            tmpListaMenu: '',
            modalMenu: false,
            titulo: '',
            opciones: 0,
            menu: {
                'idmenu': '',
                'name': '',
                'url': '',
                'icon': '',
                'orden': '',
            },
            grupos: [],
            grupoSelect: {},
            txt_boton: '',
            color_boton: '',
            usuario: '',
            id_autorizado: '',
            mensaje: 'Hey !!!! ¿Qué quiere hacer?, este contenido es restringido, consulte con los encargados del desarrollo.',
        }
    },
    mounted() {
        let me = this;
        me.usuario = JSON.parse(localStorage.getItem('usuario'))
        me.id_autorizado = me.usuario.idusuario;
        me.getMenu();
    },
    methods: {
        getMenu() {
            let me = this;
            me.$vs.loading();
            me.$http.get(this.$server_url + 'listaMenu')
                .then(res => {
                    me.tmpListaMenu = res.data;
                    console.log(me.tmpListaMenu);
                    me.perfiles();
                    me.$vs.loading.close();
                })
                .catch(err => {
                    console.log(err)
                    me.$vs.loading.close();
                })
            me.$http.get(this.$server_url + 'grupo')
                .then(res => {
                    me.grupos = res.data
                    console.log(me.grupos)
                })
        },
        agregarModal() {
            let me = this;
            me.modalMenu = true;
            me.titulo = 'Agregar menú';
            me.txt_boton = 'Registrar';
            me.color_boton = 'success';
            me.menu = {
                'idmenu': '',
                'name': '',
                'url': '',
                'icon': '',
                'orden': '',
            }
            me.grupoSelect = {}
        },
        editarModal(item) {
            let me = this;
            me.modalMenu = true;
            // console.log(item)
            me.menu = item;
            me.grupoSelect = {}
            me.grupoSelect.idgrupo = item.id_group
            me.grupoSelect.nombre = item.grupo
            me.grupoSelect.detalle = item.detalle
            me.grupoSelect.orden = item.orden
            me.txt_boton = 'Editar';
            me.titulo = 'Editar menú';
            me.color_boton = 'warning';

        },
        agregar_editar() {
            let me = this;
            // console.log(me.menu, me.grupoSelect.id)
            // return
            me.modalMenu = false;
            // if (me.id_autorizado == 5103 || me.id_autorizado == 35748 || me.id_autorizado == 5763 || me.id_autorizado == 14818) {
            let datos = new FormData();
            datos.append('idmenu', me.menu.idmenu)
            datos.append('url', me.menu.url)
            datos.append('name', me.menu.name)
            datos.append('icon', me.menu.icon)
            datos.append('orden', me.menu.orden)
            datos.append('id_group', me.grupoSelect.idgrupo)
            me.$http.post(this.$server_url + 'menu', datos)
                .then(res => {
                    console.log(res.data)
                    me.$vs.notify({
                        text: 'Contenido agregado correctamente',
                        color: 'success',
                        iconPack: 'feather',
                        icon: 'icon-check'
                    })
                    me.getMenu();
                })
                .catch(err => {
                    console.log(err)
                })
            // } else {
            //     me.$vs.notify({
            //         text: me.mensaje,
            //         time: 10000,
            //         color: 'danger',
            //         iconPack: 'feather',
            //         icon: 'icon-alert-triangle'
            //     })
            //     return
            // }

        },
        perfiles() {
            let me = this;
            console.log(me.opciones,me.tmpListaMenu);
            me.listaMenu = [];
            if (me.opciones == 0) {
                me.listaMenu = me.tmpListaMenu;
            }
            if (me.opciones == 'admin') {
                for (let index = 0; index < me.tmpListaMenu.length; index++) {
                    if (me.tmpListaMenu[index].grupo == 'Administrador') {
                        me.listaMenu.push(me.tmpListaMenu[index]);
                    }
                }
            }
            if (me.opciones == 'docente') {
                for (let index = 0; index < me.tmpListaMenu.length; index++) {
                    if (me.tmpListaMenu[index].grupo == 'Docentes') {
                        me.listaMenu.push(me.tmpListaMenu[index]);
                    }
                }
            }
            if (me.opciones == 'estudiante') {
                for (let index = 0; index < me.tmpListaMenu.length; index++) {
                    if (me.tmpListaMenu[index].grupo == 'Estudiantes') {
                        me.listaMenu.push(me.tmpListaMenu[index]);
                    }
                }
            }
            if (me.opciones == 'vendedor') {
                for (let index = 0; index < me.tmpListaMenu.length; index++) {
                    if (me.tmpListaMenu[index].grupo == 'Vendedor') {
                        me.listaMenu.push(me.tmpListaMenu[index]);
                    }
                }
            }

        },
        confirmaEliminar(item) {
            let me = this;
            me.id_eliminar = item.idmenu;
            // console.log( me.id_eliminar )
            // return
            me.$vs.dialog({
                type: 'confirm',
                color: 'danger',
                title: 'Confirmar',
                text: 'Seguro desea eliminar este item?',
                acceptText: 'Aceptar',
                cancelText: 'Cancelar',
                accept: me.eliminarMenu
            })
            // if (me.id_autorizado == 5103 || me.id_autorizado == 35748 || me.id_autorizado == 5763 || me.id_autorizado == 14818) {
            // } else {
            //     me.$vs.notify({
            //         text: me.mensaje,
            //         time: 10000,
            //         color: 'danger',
            //         iconPack: 'feather',
            //         icon: 'icon-alert-triangle'
            //     })
            //     return
            // }
        },
        eliminarMenu() {
            let me = this;
            me.$vs.loading();
            me.$http.get(this.$server_url + 'eliminaMenu/' + me.id_eliminar)
                // axios.get('http://localhost:8000/api/eliminaMenu/' + me.id_eliminar)
                .then(res => {
                     console.log( res.data )
                    me.$vs.notify({
                        text: 'Item eliminado correctamente.',
                        color: 'success',
                        iconPack: 'feather',
                        icon: 'icon-check'
                    })
                    me.$vs.loading.close();
                    me.getMenu();
                })
                .catch(er => {
                     console.log(er)
                    me.$vs.loading.close();
                })
        }
    }
}
</script>
